





















 import { Component, Vue } from 'vue-property-decorator';
 import { BTable } from 'bootstrap-vue';

@Component({
  name: 'AgroTableDefault',
  components: {
    BTable,
  }
})
export default class AgroTableDefault extends Vue {

}
